module.exports = __webpack_public_path__ + "img/neotag-bag-tag-activ8-dark.3957eca7.png";